module.exports = __webpack_public_path__ + "static/media/bar5.1faf6e30.svg";